import { Component, Input, OnInit } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ChooseIconComponent, } from 'vhobjects-service';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';
// import { ChooseIconComponent } from '../../../basic/icon/choose-icon/choose-icon.component';

@Component({
  selector: 'app-date-create-product-admin-config',
  templateUrl: './date-create-product-admin-config.component.html',
  styleUrls: ['./date-create-product-admin-config.component.scss']
})
export class AtwDateCreateProductAdminConfig extends AtwUpdateDbComponent implements OnInit {
@Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
   @Input() type_config : string; // xác định trang đang ở page hay preview
   @Input() device: any // xác định trang ở thiết bị desktop hay mobile
   @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
   @Input() config: any;
   @Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
   @Input() staticdata: any; // là dữ liệu staticdata từ database
 
   isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
   currentViewAll: any = {}; 
   styles_field = [
     {
       title: 'hieu_ung_chuyen_dong',
       index: 1,
     }
   ];

  effect_hover = [];
  effect_hover_data: any = {};
   configMode: 'basic' | 'advanced' = 'basic';
  /** Biến lưu cấu hình tự động dịch có đang bật không? Tránh gọi hàm getSetups_byFields quá nhiều lần */
  private isAutoTranslate: boolean;

 
   constructor(
     public vhQueryAutoWeb: VhQueryAutoWeb,
     private http: HttpClient,
     private dialog: MatDialog,
     public vhEventMediator: VhEventMediator,
         public functionService: FunctionService
   ) {
      super(vhQueryAutoWeb, vhEventMediator, functionService);
   }
 
   ngOnInit(): void {
    this.vhQueryAutoWeb.getSetups_byFields({ type: { $in: ['auto_translate_language'] } })
      .then((res: any) => {
        this.isAutoTranslate = res.find((ele) => ele.type == 'auto_translate_language').auto_translate_language;
      });
     
     // phần này get dữ liệu json
     forkJoin([
       this.http.get('assets/data/effects/text.json'),
     ]) .subscribe(([ effects]:any)=>{
       this.effect_hover = effects;
       this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
     })
   }
 
   ngOnChanges(): void {
     if (this.effect_hover) {
       this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
       this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
     }
   }
 
   /**
    * Cập nhật text-shadow
    */
   handleSetTextShadow() {
     this.class['date-create-product__wrapper']['filter'] = `drop-shadow(${this.config['filter']['offset_x']}px ${this.config['filter']['offset_y']}px ${this.config['filter']['blur_radius']}px ${this.config['filter']['shadow_color']})`;
   }
 
   /** Định dạng hiệu ứng văn bản (phong cách và kiểu cọ)
    * @param action : trả về hiệu ứng văn bản đã chọn
    */
   dispatchStyles(action) {
     // reset những style khác trước
     switch (action) {
       case 'Đổ bóng':
         this.config['text_style'] = 'shadow';
         this.class['date-create-product__content']['-webkit-text-stroke-width'] = "0";
         this.class['date-create-product__wrapper']['background-color'] = "";
         this.class['date-create-product__wrapper']['border-top-left-radius'] = "0px";
         this.class['date-create-product__wrapper']['border-top-right-radius'] = "0px";
         this.class['date-create-product__wrapper']['border-bottom-right-radius'] = "0px";
         this.class['date-create-product__wrapper']['border-bottom-left-radius'] = "0px";
         this.handleSetTextShadow();
         break;
 
       case 'Tạo stroke':
         this.config['text_style'] = 'stroke';
         this.class['date-create-product__wrapper']['filter'] = "";
         this.class['date-create-product__wrapper']['background-color'] = "";
         this.class['date-create-product__wrapper']['border-top-left-radius'] = "0px";
         this.class['date-create-product__wrapper']['border-top-right-radius'] = "0px";
         this.class['date-create-product__wrapper']['border-bottom-right-radius'] = "0px";
         this.class['date-create-product__wrapper']['border-bottom-left-radius'] = "0px";
         this.class['date-create-product__content']['-webkit-text-stroke-width'] = '2px';
         break;
 
       case 'background':
         this.config['text_style'] = 'background';
         this.class['date-create-product__content']['-webkit-text-stroke-width'] = "0";
         this.class['date-create-product__wrapper']['filter'] = "";
         this.class['date-create-product__wrapper']['background-color'] = "#008848";
         break;
 
       default:
         this.config['text_style'] = '';
         this.class['date-create-product__content']['-webkit-text-stroke-width'] = "0";
         this.class['date-create-product__wrapper']['filter'] = "";
         this.class['date-create-product__wrapper']['background-color'] = "";
         this.class['date-create-product__wrapper']['border-top-left-radius'] = "0px";
         this.class['date-create-product__wrapper']['border-top-right-radius'] = "0px";
         this.class['date-create-product__wrapper']['border-bottom-right-radius'] = "0px";
         this.class['date-create-product__wrapper']['border-bottom-left-radius'] = "0px";
     }
 
     this.updateObject();
   }
 
   
   /**
    * Hàm này dùng để mở dialog của component icon
    */
   openDialogChooseIcon() {
     const dialogRef = this.dialog.open(ChooseIconComponent, {
       width: '80vw',
       height: '70vh',
       disableClose: false,
     });
 
     dialogRef.afterClosed().subscribe((result) => {
       if (result) {
         this.config['icon']['icon_name'] = result.icon;
         this.updateConfig();
       }
     });
   }
 
   customize = []
 
   /**
  //   * Hàm update class
  //   */
  //  updateClass() {
  //    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
  //      .then((bool: any) => {
         
  //      })
  //  }
 
  //  /**
  //   * Hàm update config
  //   */
  //  updateConfig() {
  //    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
  //      .then((bool: any) => {
         
  //      })
  //  }
 
  //  /**
  //   * Hàm update object vào database.
  //   */
  //  updateObject() {
  //    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
  //      .then((bool: any) => {
         
  //      })
  //  }
 
   /**
    * Hàm này dùng để mở rộng phần cấu hình.
    * @param field_text : trả về phần tử được chọn của mảng style_field
    */
   openViewAll(field_text) {
     this.currentViewAll = field_text;
     this.isViewAll = !this.isViewAll;
   }
 
   /**
    * Hàm này dùng để cho phép mở menu config .
    * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
    * @param: value
    */
   openHandler(value: string): void {
     for (const key in this.openMap) {
       if (key !== value) {
         this.openMap[key] = false;
       }
     }
   }
   openMap: { [name: string]: boolean } = {
     menu1: true,
     menu2: false,
     menu3: false,
     menu4: false,
     menu5: false
   };

  /**
   * Update nội dung 
   * @param fieldContent - Tên trường để cập nhật nội dung
   * @param isAriaLabel - Có phải là trường dạng aria-label không
   * @example
   * data = [ { langCode: 'vi', translatedText: 'Bản đồ Việt Nam' } ]
   */
  updateContent(fieldContent, isAriaLabel = false) {
    if (this.isAutoTranslate) {
      this.functionService.translateToMultipleLanguages(
        isAriaLabel 
        ? this.staticdata.accessibility?.[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
        : this.staticdata[`${fieldContent}_${this.functionService.selectedLanguageCode}`]
      )
      .subscribe({
        next: (data) => {
          // console.log('data', data)
          this.functionService.multi_languages.forEach(lang => {
            // Trường hợp là content nằm trong staticdata và nằm bằng cấp với accessibility
            if (!isAriaLabel) {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            } 
            // Trường hợp là field nằm trong accessibility
            else {
              if (
                this.functionService.selectedLanguageCode != lang.code 
                && !this.staticdata.accessibility?.[`${fieldContent}_${lang.code}`]
              ) {
                this.staticdata.accessibility[`${fieldContent}_${lang.code}`] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            }
          });
          this.updateStaticData();
        },
        error: (err) => {
          console.error('Lỗi dịch thuật:', err);
        }
      });
    } else {
      this.updateStaticData();
    }
  }
}
